import React, { memo, useMemo } from 'react';

import { IconButton, Tooltip } from '@mui/material';
import { ChatIcon, ExternalLinkIcon, QuestionIcon } from '@sharedCR/coreDesignSystem/icons';
import MenuPopoverCDS from '@sharedCR/coreDesignSystem/MenuPopoverCDS';
import {
  checkIsIntercomEnabled,
  openIntercomMessenger,
  openIntercomTicketsPortal,
} from 'app/services/intercom';

import { IconSize } from 'constants/coreDesignSystem';
import usePopover from 'hooks/usePopover';

import { iconButtonStyles } from '../Header.styles';

import { HelpButtonTestIds } from './HelpButton.testIds';

const HelpButton = () => {
  const { anchorEl, onSetAnchorElement, onClearAnchorElement } = usePopover();

  const items = useMemo(
    () => [
      {
        text: 'Questions and chat',
        icon: <ChatIcon size={IconSize[20]} />,
        onClick: openIntercomMessenger,
        'data-testid': HelpButtonTestIds.MESSENGER_ITEM,
      },
      {
        text: 'Company tickets',
        description: 'Opens the customer portal in a new tab',
        icon: <ExternalLinkIcon size={IconSize[20]} />,
        onClick: openIntercomTicketsPortal,
        'data-testid': HelpButtonTestIds.TICKETS_PORTAL_ITEM,
      },
    ],
    [],
  );

  if (!checkIsIntercomEnabled()) {
    return null;
  }

  return (
    <>
      <Tooltip title="Help">
        <IconButton
          disableRipple
          aria-label="Help"
          data-testid={HelpButtonTestIds.OPEN_MENU}
          sx={iconButtonStyles}
          onClick={onSetAnchorElement}
        >
          <QuestionIcon size={IconSize[20]} />
        </IconButton>
      </Tooltip>
      <MenuPopoverCDS anchorEl={anchorEl} items={items} onClose={onClearAnchorElement} />
    </>
  );
};

export default memo(HelpButton);
